import Manish from "../team/team-1.png";
import Sagnik from "../team/team-2.png";
import Shubham from "../team/team-3.png";

const overAllCoordinaters = [
  {
    Name: "Manish Kr Barnwal",
    Photo: Manish,
    position:
      "GitHub Campus Expert",
    Domain: "Lead Organizer",
    facebook: "https://www.facebook.com/imanishbarnwal",
    twitter: "https://twitter.com/imanishbarnwal",
    github: "https://github.com/imanishbarnwal",
    linkedin: "https://www.linkedin.com/in/imanishbarnwal/",
  },
  {
    Name: "Sagnik Mitra",
    Photo: Sagnik,
    position:
      "SDE @Odessa",
    Domain: "Lead Organizer",
    facebook: "https://www.facebook.com/sagnikmitr",
    twitter: "https://twitter.com/MitraSagnik",
    github: "https://github.com/sagnikmitra",
    linkedin: "https://www.linkedin.com/in/sagnikmitra/",
  },
  {
    Name: "Shubham Tribedi",
    Photo: Shubham,
    position:
      "Program Coordinator @Unacademy",
    Domain: "Lead Organizer",
    facebook: "https://www.facebook.com/shubham.tribedi",
    twitter: "https://twitter.com/shubham_tribedi",
    github: "https://github.com/CoderShubham2000",
    linkedin: "https://www.linkedin.com/in/shubham-tribedi/",
  },
];

export default overAllCoordinaters;
